import React, { useLayoutEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';

// Scroll to top on route change and initial load
const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    // Force scroll to top synchronously before paint
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

import Layout from './components/Layout';
import Hero from './components/Hero';
import ManifestoSection from './components/ManifestoSection';
import SplitSection from './components/SplitSection';
import ResearchSection from './components/ResearchSection';
import CTASection from './components/CTASection';
import ResearchInstitutionsBar from './components/ResearchInstitutionsBar';
import PrivacyPolicy from './components/PrivacyPolicy';
import AppPrivacyPolicy from './components/AppPrivacyPolicy';
import AppTermsOfService from './components/AppTermsOfService';
import DataUsageOverview from './components/DataUsageOverview';

import TechnologyPage from './components/TechnologyPage';
import ResearchPage from './components/ResearchPage';
import AppPage from './components/AppPage';
import AboutPage from './components/AboutPage';
import MeditationPreviewPage from './components/MeditationPreviewPage';



// Home page content (without Navbar/Footer - handled by Layout)
const HomeContent: React.FC = () => {
  return (
    <main id="main-content" className="w-full" role="main">
      <Hero />
      <ResearchInstitutionsBar />
      <ManifestoSection />
      <SplitSection />
      <ResearchSection />
      <CTASection />
    </main>
  );
};

import MaintenancePage from './components/MaintenancePage';

// Set to true to enable maintenance mode across the entire site
const isMaintenanceMode = false;

const App: React.FC = () => {
  if (isMaintenanceMode) {
    return <MaintenancePage />;
  }

  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="w-full min-h-screen bg-canvas selection:bg-text-primary selection:text-canvas overflow-x-clip">
        {/* Skip to main content link for keyboard navigation */}
        <a
          href="#main-content"
          className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-[100] focus:px-4 focus:py-2 focus:bg-white focus:text-black focus:rounded focus:outline-2 focus:outline-white focus:outline-offset-2 focus-visible:outline-2 focus-visible:outline-white focus-visible:outline-offset-2"
          style={{ left: 0 }}
        >
          Skip to main content
        </a>
        <Routes>
          {/* Layout wrapper keeps Navbar mounted */}
          <Route element={<Layout />}>
            <Route path="/" element={<HomeContent />} />

            <Route path="/technology" element={<TechnologyPage />} />
            <Route path="/research" element={<ResearchPage />} />
            <Route path="/app" element={<AppPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/meditations/:id" element={<MeditationPreviewPage />} />
          </Route>
          {/* Legal pages without layout */}
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/app-privacy" element={<AppPrivacyPolicy />} />
          <Route path="/app-terms" element={<AppTermsOfService />} />
          <Route path="/app-data-usage" element={<DataUsageOverview />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
};

export default App;

